import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const STORAGE_KEY = 'chat_sound_enabled';

/**
 * Subtelny dzwiek przy nowej wiadomosci/powiadomieniu (Patryk 29.09.2026). Wlacznik w
 * "Ustawienia lokalne" (menu), domyslnie wlaczony - patrz MenuComponent.
 * Syntezowany przez Web Audio API zamiast pliku audio w assets - jeden krotki, cichy
 * "ding" bez potrzeby dolaczania/licencjonowania zadnego zasobu binarnego.
 */
@Injectable({ providedIn: 'root' })
export class ChatSoundService {
  readonly enabled$ = new BehaviorSubject<boolean>(this.readStoredEnabled());

  private audioContext?: AudioContext;

  setEnabled(enabled: boolean): void {
    this.enabled$.next(enabled);
    localStorage.setItem(STORAGE_KEY, enabled ? '1' : '0');
  }

  play(): void {
    if (!this.enabled$.value) {
      return;
    }

    try {
      const ctx = this.getAudioContext();
      const now = ctx.currentTime;

      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(880, now);

      // Szybki, cichy "ding" - narastanie 15ms, zanik do 0 w ~350ms - zeby nie brzmial jak
      // alarm i nie zlewal sie w kakofonie przy kilku wiadomosciach pod rzad.
      gain.gain.setValueAtTime(0, now);
      gain.gain.linearRampToValueAtTime(0.12, now + 0.015);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.35);

      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(now);
      osc.stop(now + 0.4);
    } catch {
      // Przegladarka moze odmowic AudioContext bez wczesniejszej interakcji usera (autoplay
      // policy) - pomijamy cicho, tak samo jak przy Notification API w browser-notify.ts.
    }
  }

  private getAudioContext(): AudioContext {
    if (!this.audioContext) {
      this.audioContext = new AudioContext();
    }
    return this.audioContext;
  }

  private readStoredEnabled(): boolean {
    return localStorage.getItem(STORAGE_KEY) !== '0';
  }
}
